<template>
  <v-card
    class="mx-auto info-card"
    flat
  >
    <v-toolbar short flat height="48">
      <v-toolbar-title>
        <v-icon>mdi-chart-arc</v-icon>
        {{ lang.historic.stats.title }}
      </v-toolbar-title>
    </v-toolbar>
    <div class="info-card-content">
      <Filters
        :value="filters"
        @clearFilters="$emit('clearFilters', true)"
      />
      <Chart v-if="0 === 1" />
      <Results />
    </div>
  </v-card>
</template>

<script>
import Filters from './info/Filters'
import Chart from './info/Chart'
import Results from './info/Results'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Filters, Chart, Results },
  mixins: [ appdata, utils ],
  props: {
    filters: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
